// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".revico-widget .revico-community-talk-reply-details-reply-tenant-icon {\n  position: absolute;\n  top: -24px;\n  right: 0;\n  padding: 4px 12px;\n  font-size: 0.8em;\n  font-weight: bold;\n  background-color: var(--base-bg-color);\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
